<template>
	<h-disclosure
		v-slot="{open}"
		:default-open="isOpen"
		as="div"
		class="w-full border-b"
	>
		<v-disclosure-button
			class="flex w-full items-start justify-between space-x-md px-sm py-md pr-md text-left"
			:class="{
				'bg-gray-50 font-sans-caption text-xl leading-7 font-bold': open,
			}"
			@click="open ? $emit('close') : $emit('open')"
		>
			<slot name="button" />

			<div>
				<v-icon v-if="open" icon="minus" class="text-xl"></v-icon>

				<v-icon v-else icon="add" class="text-xl"></v-icon>
			</div>
		</v-disclosure-button>

		<v-disclosure-panel :class="{'bg-gray-50 px-sm pb-md': open}">
			<slot name="content" />
		</v-disclosure-panel>
	</h-disclosure>
</template>

<script setup lang="ts">
defineProps<{
	isOpen?: boolean;
}>();

defineEmits<{
	(event: "open"): void;
	(event: "close"): void;
}>();
</script>
